import React from "react";

const colaboraciones = [
    {
        id: 1,
        titulo: "Chifa, la perrita",
        descripcion:
            "En EquipoMAG. nos comprometimos a recaudar para la operacion de la perrita Chifa.",
        imagenUrl: "/assets/images/colaboraciones/chifa.jpg",
        enlace: "https://www.facebook.com/photo/?fbid=1000467288078731&set=a.712880880170708",
    },
    {
        id: 2,
        titulo: "Onda Guillena Radio",
        descripcion:
            "Desde 2022 colaboramos periódicamente con el programa Guillena al Día, donde tratamos diferentes temas de nutrición y psicología.",
        imagenUrl: "/assets/images/colaboraciones/onda-guillena-radio.png",
        enlace: "https://ondaguillena.org/",
    },
    {
        id: 3,
        titulo: "Alcalá del Río C.F.",
        descripcion:
            "Durante la temporada 2022/23 nos hicimos cargo del control nutricional del club.",
        imagenUrl: "/assets/images/colaboraciones/alcala-del-rio-cf.jpg",
        enlace: "https://www.instagram.com/alcaladelrioclubdefutbol/",
    },
    {
        id: 4,
        titulo: "El Vuelo del Pingüino",
        descripcion:
            "Desde 2022 colaboramos periódicamente, tratando diferentes temas de nutrición y psicología.",
        imagenUrl: "/assets/images/colaboraciones/el-vuelo-del-pinguino.jpg",
        enlace: "https://www.youtube.com/watch?v=nqhuwoMfjbw",
    },
    {
        id: 5,
        titulo: "Polvorón",
        descripcion:
            "Polvorón es un burrito maltratado y abandonado. El equipo se ha hecho cargo del pago pendiente del veterinario.",
        imagenUrl: "/assets/images/colaboraciones/polvoron.webp",
        enlace: "https://www.facebook.com/magj1972/photos/pcb.1801118200237479/1801118160237483",
    },
    {
        id: 6,
        titulo: "APAC",
        descripcion:
            "Colaboramos con la asociación en 2020 mediante la venta de mascarillas solidarias, cuya recaudación fue destinada a la gran labor que realizan.",
        imagenUrl: "/assets/images/colaboraciones/apac.jpg",
        enlace: "https://www.facebook.com/apaccastilblanco/",
    },
    {
        id: 7,
        titulo: "Fundación TAS",
        descripcion:
            "Mejorar la calidad de vida de cada persona con discapacidad y la de sus familias en el entorno rural para que sea lo más plena, mediante una atención individualizada, inclusiva y adaptada a las necesidades de cada etapa de su vida y con la participación solidaria de voluntariado.",
        imagenUrl: "/assets/images/colaboraciones/fundacion-tas.jpg",
        enlace: "https://www.fundaciontas.org/",
    },
    {
        id: 8,
        titulo: "Fundación OM Shanti",
        descripcion:
            "Propiciar y fomentar la convivencia con familias autóctonas, preferentemente del ámbito rural, de India y Nepal. Mensualmente realizamos una donación con el fin de asegurar la manutención de los niños y niñas sin recursos.",
        imagenUrl: "/assets/images/colaboraciones/fundacion-om-shanti.jpg",
        enlace: "http://omshantiyoga.es/",
    },
    {
        id: 9,
        titulo: "Reina",
        descripcion:
            "Reina es una perrita víctima de maltrato, presentaba tres heridas. Equipo MAG se hizo cargo del gasto por sus intervenciones.",
        imagenUrl: "/assets/images/colaboraciones/reina.jpg",
        enlace: "https://www.facebook.com/magj1972/photos/a.501335686882410/1215312688818036/?type=3&theater",
    },
    {
        id: 10,
        titulo: "La Quinta Huella",
        descripcion:
            "Ayudamos a los animales de nuestro municipio. Nuestro primer proyecto: Los Jardines. Difundimos animales perdidos y encontrados en Alcalá del Río. Colaboramos con ayuda de nuestros clientes mediante recogida de pienso y comida húmeda para gatos.",
        imagenUrl: "/assets/images/colaboraciones/la-quinta-huella.jpg",
        enlace: "https://www.facebook.com/laquintahuella/",
    },
    {
        id: 11,
        titulo: "Javier Reja",
        descripcion:
            "Atleta de las modalidades de paracanoe y handbike. Oro en el Campeonato del Mundo 2013, plata en el Campeonato del Mundo 2015 y plata en el Campeonato de Europa 2016. Colaboramos en su preparación para Río 2016.",
        imagenUrl: "/assets/images/colaboraciones/javier-reja.jpeg",
        enlace: "https://www.instagram.com/javireja/",
    },
    {
        id: 12,
        titulo: "LEA La Esperanza Animal",
        descripcion:
            "LEA es una asociación que se dedica especialmente a socorrer peludos abandonados y necesitados. Colaboramos con ayuda de nuestros clientes mediante recogida de pienso.",
        imagenUrl: "/assets/images/colaboraciones/lea.jpg",
        enlace: "https://www.instagram.com/lea_asociacion/",
    },
    {
        id: 13,
        titulo: "Recogida de ropa",
        descripcion:
            "Planteamos a nuestros clientes donar la ropa que se iba quedando grande. Fue todo un éxito. La ropa se donó a Cáritas.",
        imagenUrl: "/assets/images/colaboraciones/recogida-de-ropa.jpg",
        enlace: "https://www.facebook.com/magj1972/photos/a.513009595715019/694762374206406/?type=3&theater",
    },
    {
        id: 14,
        titulo: "Fran Vaquero",
        descripcion:
            "Jugador de la selección Española de Fútbol de Amputados.",
        imagenUrl: "/assets/images/colaboraciones/fran-vaquero.jpeg",
        enlace: "https://www.facebook.com/francisco.vaqueroescobar.3",
    },
    {
        id: 15,
        titulo: "La Magía De Los Reyes",
        descripcion:
            "En las navidades de 2024-2025 apadrinamos 3 niños y niñas con escasos recursos para que pudieran tener sus regalos de reyes.",
        imagenUrl: "/assets/images/colaboraciones/lamagiadelosreyes.jpg",
        enlace: "https://www.facebook.com/photo/?fbid=1177402023718589&set=a.712880880170708",
    },
    {
        id: 16,
        titulo: "Colaboración con Fundación TAS",
        descripcion:
            "Durante el invierno de 2025 realizamos una colaboración con Fundación TAS. Fuimos a sus instalaciones con el fin de compartir su labor mediante un dia de convivencia, también ayudamos económicamente directamente y ayuda a la recaudación.",
        imagenUrl: "/assets/images/colaboraciones/fundacion-tas.jpg",
        enlace: "https://www.facebook.com/magj1972/videos/1182593879363365",
    },
];

const ColaboracionesSection = () => {
    return (
        <section className="prt-row blog-section clearfix">
            <div className="container">
                <p>
                    Desde nuestra constitución, tenemos muy presente la RSC para la contribución activa y voluntaria a la mejora social, económica y responsabilidad ambiental.
                    No podemos cambiar el mundo, pero si el que nos rodea.</p>
                <div className="row row-equal-height">
                    {colaboraciones.map((colaboracion) => (
                        <div key={colaboracion.id} className="col-lg-4 col-md-6 col-sm-6">
                            <div className="featured-imagebox featured-imagebox-post style1">
                                <div className="featured-thumbnail">
                                    <img
                                        width="720"
                                        height="500"
                                        className="img-fluid"
                                        src={colaboracion.imagenUrl}
                                        alt={colaboracion.titulo}
                                    />
                                    <div className="post-meta">
                                        {/* <div className="prt-meta-date">{colaboracion.fecha.dia}</div> */}
                                        {/* <div className="prt-meta-month">{colaboracion.fecha.mes}</div> */}
                                    </div>
                                </div>
                                <div className="featured-content">
                                    <div className="featured-content-inner">
                                        <div className="post-header">
                                            <div className="post-title featured-title">
                                                <h3>
                                                    <a href={colaboracion.enlace}>{colaboracion.titulo}</a>
                                                </h3>
                                            </div>
                                            <div className="blog-tag">
                                                <a href={colaboracion.enlace} className="imagebox-category-blog">
                                                    Ver más
                                                </a>
                                            </div>
                                        </div>
                                        <p>{colaboracion.descripcion}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ColaboracionesSection;